<template>
  <div>
    <a-modal
      centered
      :title="`快速跟进【${member ? (member.name||'匿名') : '-'}】`"
      :visible="visible"
      :confirm-loading="submitting"
      @cancel="on_cancel"
      @ok="on_submit"
      :width="920"
      :after-close="after_close"
      :mask-closable="false"
      ok-text="提交"
    >
      <a-row :gutter="36">
        <a-col :span="12">
          <h2>客户信息</h2>
          <a-descriptions size="small" v-if="member" bordered style="margin-bottom:24px" :column="1">
            <a-descriptions-item label="手机号码">{{ member.mobile }}</a-descriptions-item>
            <a-descriptions-item label="录入信息" v-if="member.user">
              {{ member.user.name }}
              • {{ moment(member.created_at * 1000).format("YYYY-MM-DD H:m") }}
            </a-descriptions-item>
          </a-descriptions>

          <a-form-model v-model="form">

            <a-form-model-item label="客户备注">
              <a-textarea v-model="form.member_remark" class="input" />
            </a-form-model-item>

            <a-form-model-item label="跟进内容">
              <a-textarea v-model="form.content" class="input" placeholder="填写本次跟进内容..." />
            </a-form-model-item>

            <a-form-model-item label="下次跟进时间">
              <a-date-picker show-time v-model="form.reminder_at" placeholder="清选择日期..."
                             valueFormat="YYYY-MM-DD HH:mm" />
            </a-form-model-item>
            <a-form-model-item label="客户等级">
              <a-radio-group class="radio-tooltip" v-model="form.member_level" button-style="solid">
                <a-radio-button :value="item.value" v-for="item in level_array" :key="item.value">
                  <a-tooltip :mouseEnterDelay="0" :mouseLeaveDelay="0">
                    <template slot="title">
                      {{ item.name }}
                    </template>
                    <span style="padding: 0 15px;">{{ item.value }}</span>
                  </a-tooltip>
                </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-form-model>
        </a-col>
        <a-col :span="12" style="overflow-y: auto;">
          <h2>历史跟进记录</h2>
          <a-radio-group v-model="revisit_type" button-style="solid" style="margin-bottom:16px;"
                         :disabled="!data_content.length">
            <a-radio-button value="all">
              全部
            </a-radio-button>
            <a-radio-button value="text">
              跟进记录
            </a-radio-button>
            <a-radio-button value="system">
              操作记录
            </a-radio-button>
          </a-radio-group>

          <a-list
            item-layout="horizontal"
            :data-source="render_revisit(data_content)"
            rowKey="id"
            class="content-list"
            :loading="loading"
          >
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-list-item-meta
                  :description="item.content">
                <div slot="title" class="title">
                  <div class="left">
                    {{ item.user ? item.user.name : "【已删除】" }}
                    <span
                      v-html="$options.filters['friendly'](moment(item.time * 1000).format('YYYY-MM-DD HH:mm'))"
                    ></span>
                  </div>

                  <div class="left" v-if="item.trademark" style="margin-right: -10px !important;">
                    <a :href="'https://fsadmin.shoptm.cn/trademark/whole?markName='+item.trademark.markName" target="_blank" style="text-decoration: none;">
                      <img style="width: 50px;" :src="item.trademark !== null ? item.trademark.logo :null">
                    </a>
                  </div>
                  <div class="left" v-if="item.trademark">
                    <a :href="'https://fsadmin.shoptm.cn/trademark/whole?markName='+item.trademark.markName" target="_blank" style="text-decoration: none;">
                      <p style="margin-bottom: 0px !important;">商标名称：{{item.trademark.markName}}</p>
                      <p>注册号：{{item.trademark.applyNo}}</p>
                    </a>
                  </div>

<!--                  <div class="right">
                    <a-popconfirm
                      title="是否删除该条跟进记录？"
                      ok-text="是"
                      cancel-text="否"
                      @confirm="on_delete(item)"
                    >
                      <a-icon type="delete" />
                    </a-popconfirm>
                  </div>-->
                </div>
                <a-avatar slot="avatar" :src="item.user?item.user.avatar:null" />
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>
<script>
import moment from "moment";

export default {
  data() {
    return {
      visible: false,
      callback: false,
      loading: false,
      member: null,
      submitting: false,
      data_show: undefined,
      data_content: [],
      revisit_type: "all",
      form: {
        member_id: null,
        reminder_at: null,
        content: null,
        member_level: null,
        apply_no: null,
        member_remark: null
      }
    };
  },
  watch: {
    type(e) {
    }
  },
  created() {
    this.$event_bus.$on("visible_member_revisit", (member, callback, apply_no = null) => {
      this.visible = true;
      this.member = member;
      this.form.member_level = member.level;
      this.form.member_remark = member.remark;
      this.form.member_id = member.id;
      this.form.apply_no = apply_no;
      this.callback = callback;
      this.load();
    });
  },
  methods: {
    moment,

    load() {
      this.loading = true;
      this.$http
        .get(`member/revisit/${this.member.id}`)
        .then((res) => {
          if (res.success) {
            this.data_content = res.data;
            this.form.member_level = res.member.level;
            this.form.member_remark = res.member.remark;
            this.member = res.member;
          }
        })
        .catch(() => {
        })
        .then(() => {
          this.loading = false;
        });
    },
    render_revisit() {
      if (this.revisit_type === "text") {
        return this.data_content.filter((v) => v.type == "text");
      }

      if (this.revisit_type === "system") {
        return this.data_content.filter((v) => !!v.is_system);
      }

      if (this.revisit_type === "tel") {
        return this.data_content.filter((v) => v.type == "audio");
      }

      return this.data_content;
    },
    on_cancel() {
      this.visible = false;
    },
    on_submit() {
      this.submitting = true;
      this.revisit_type = "all";
      this.$http
        .post(`member/revisit`, this.form)
        .then((res) => {
          if (res.success) {
            this.form.content = undefined;
            if (this.callback) {
              this.callback();
            }

            this.load();
            this.$message.success(res.message);

            this.visible = false;
          } else {
            this.$error({ title: "失败", centered: true, content: res.message });
          }
        })
        .catch(() => {
        })
        .then(() => {
          this.submitting = false;
        });
    },
    after_close() {
      this.form.content = undefined;
      this.form.reminder_at = undefined;
      this.data_content = [];
    },
    on_delete(item) {
      this.$http
        .delete("/member/revisit/" + item.id)
        .then((res) => {
          if (!res.success) {
            this.$error({
              title: "失败",
              content: res.message
            });
          } else {
            if (this.callback) {
              this.callback();
            }

            this.data_content.splice(
              this.data_content.findIndex((v) => v.id == item.id),
              1
            );
          }
        })
        .catch(() => {
        })
        .then(() => {
        });
    }
  }
};
</script>

<style lang="less" scoped>
.content-list {
  min-height: 200px;
  max-height: 600px;
}

.post-content {
  display: flex;
  margin-bottom: 24px;
}

.info {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  .avatar {
    margin-right: 12px;

    img {
      width: 46px;
      height: 46px;
      border-radius: 50%;
    }
  }

  .detail {
    flex: 1;

    .name {
      font-size: 18px;
      margin-bottom: 2px;
    }

    .desc {
      font-size: 12px;
    }
  }

  .stat {
    display: flex;
  }
}

.photo {
  .description {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.attachment {
  margin-top: 12px;

  /deep/ .ant-card-cover {
    max-height: 100px;
    overflow: hidden;
  }

  .card {
    margin-bottom: 12px;
  }
}

.title {
  display: flex;
  justify-content: space-between;

  .left {
    font-size: 12px;
  }
}

.radio-tooltip {
  /deep/ .ant-radio-button-wrapper {
    padding: 0;
  }
}
</style>
